import apiClient from "@/api/client";

export interface BackfillVMResult {
  vm_id: number;
  vm_name: string;
  ip_address: string | null;
  status: "enriched" | "already_ok" | "skipped" | "partial" | "failed";
  detail?: string;
}

export interface BackfillSummary {
  dry_run: boolean;
  enriched: number;
  already_ok: number;
  skipped: number;
  partial: number;
  failed: number;
  results: BackfillVMResult[];
}

export async function runIpamBackfill(
  dryRun: boolean = false,
): Promise<BackfillSummary> {
  const { data } = await apiClient.post<BackfillSummary>(
    "/admin/ipam/backfill",
    null,
    { params: { dry_run: dryRun } },
  );
  return data;
}
